package com.dotpx.ambient

/** Strict allowlist shared by scanned QR payloads, universal links and app links. */
class PurchaseLinkCodeParser(private val serverHost: String) {
    init { require(serverHost.matches(Regex("[A-Za-z0-9.-]+")) && !serverHost.startsWith('.') && !serverHost.endsWith('.')) }

    fun parse(value: String): String? {
        if (value.length > 2_048 || value.any { it <= ' ' || it == '\u007f' }) return null
        val uri = URI.matchEntire(value) ?: return null
        val scheme = uri.groupValues[1]
        val authority = uri.groupValues[2]
        val path = uri.groupValues[3]
        val query = when {
            scheme == "ambient" && authority == "link" && path.isEmpty() -> uri.groups[4]?.value
            scheme == "https" && authority == serverHost && path == "/link" -> uri.groups[5]?.value
            else -> return null
        } ?: return null
        val codes = mutableListOf<String>()
        for (part in query.split('&')) {
            val field = part.split('=', limit = 2)
            val key = decode(field[0]) ?: return null
            if (key == "code") {
                if (field.size != 2) return null
                codes += decode(field[1]) ?: return null
            }
        }
        return codes.singleOrNull()?.takeIf { linkingTokenPattern.matches(it) }
    }

    internal fun validPairingUrl(value: String): Boolean {
        val uri = URI.matchEntire(value) ?: return false
        return uri.groupValues[1] == "https" && uri.groupValues[2] == serverHost &&
            uri.groupValues[3] == "/link" && (uri.groups[4] == null || uri.groups[4]?.value == "lang=en") &&
            uri.groupValues[5].matches(Regex("code=[A-Za-z0-9_-]{43}"))
    }

    private fun decode(value: String): String? {
        val result = StringBuilder()
        var index = 0
        while (index < value.length) {
            val c = value[index++]
            when (c) {
                '+' -> result.append(' ')
                '%' -> {
                    if (index + 1 >= value.length) return null
                    val high = value[index++].digitToIntOrNull(16) ?: return null
                    val low = value[index++].digitToIntOrNull(16) ?: return null
                    result.append((high * 16 + low).toChar())
                }
                else -> result.append(c)
            }
        }
        return result.toString()
    }

    companion object {
        private val URI = Regex("([a-z][a-z0-9+.-]*)://([^/?#]*)([^?#]*)(?:\\?([^#]*))?(?:#(.*))?")
    }
}
